var render, staticRenderFns
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/deduct_saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31ea41b3')) {
      api.createRecord('31ea41b3', component.options)
    } else {
      api.reload('31ea41b3', component.options)
    }
    
  }
}
component.options.__file = "src/layout/components/Sidebar/Item.vue"
export default component.exports